/**
 * Styled Components - Created by cazarez on 13/02/18.
 */
import styled from 'styled-components'
import Input from 'antd/lib/input'
import { BLACK, GRAY, GRAY_LIGHTEST, WHITE } from '../../theme/colors'
import Icon from 'antd/lib/icon'

const Search = Input.Search

interface StyledProps {
  searchWidth?: string
  onHeader?: boolean
  focused?: boolean
  manualMode?: boolean
  mobile?: boolean
  store?: boolean
}
export const Container = styled.div`
  ${({ searchWidth }: StyledProps) =>
    searchWidth ? `width: ${searchWidth};` : ''};
  flex: 1;
  ${({ store }: StyledProps) => store ? `
    filter: drop-shadow(0px 4px 3px #00000061);
  ` : ''}
  .ant-input {
    ${({ onHeader }: StyledProps) =>
      onHeader ? `background-color : #f9f9f9;` : ''};
    box-shadow: 0 0 0 1px ${GRAY};
    transition: all .25s;
  }
  .ant-input:focus {
    ${({ onHeader }: StyledProps) =>
      onHeader ? `background-color : ${WHITE}` : ''};
    box-shadow: 0 0 4px 0px #474747;
  }

  .ant-input-suffix {
    font-size: 20px;
  }
  .ant-input-suffix:focus {
    background-color: ${WHITE};
  }

  .ant-btn-primary {
    color: #4d4d4d;
    border: none;
    box-shadow: none;
    border-radius: 2px !important;
    background-color: ${({ onHeader, focused }: StyledProps) =>
      focused || !onHeader ? '#e7e7e7' : '#e9e9e9'};
    border-color: ${({ onHeader, focused }: StyledProps) =>
      focused || !onHeader ? WHITE : GRAY_LIGHTEST};
  }
  animation: fade-in-right 0.35s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;
  @keyframes fade-in-right {
    0% {
      transform: translateX(50px);
      opacity: 0;
    }
    100% {
      transform: translateX(0);
      opacity: 1;
    }
  }
`

export const Text = styled.div`
  color: ${WHITE};
`
export const SearchInput = styled(Search)`
  height: 40px;
  border-radius: ${({ store }: StyledProps) => store ? '25px' : '3px'};
  background-color: ${WHITE};

  &:focus {
    background-color: ${WHITE};
  }
  ${({ store }: StyledProps) => store ? `
    .ant-input-suffix, .ant-btn-primary {
      border-top-right-radius: 25px !important;
      border-bottom-right-radius: 25px !important;
    }
    @media (min-width: 1480px) {
      height: 44px;
      .ant-btn-lg {
        height: 44px;
      }
      input::placeholder {
        font-size: 19px;
      }
    }
    @media (max-width: 698px) {
      transform: scale(0.9);
      height: 46px;
      .ant-btn-lg {
        height: 46px;
      }
      .ant-input {
        font-size: 18px;
      }
      input::placeholder {
        font-size: 18px;
        color: #909090;
      }
    }
  ` : ''}
  input {
    width: ${({ manualMode, mobile }: StyledProps) => manualMode || mobile ? '100%' : 'auto'};
    border-radius: ${({ store }: StyledProps) => store ? '25px' : '3px'};
    border: 0;
    color: ${BLACK};
    font-size: 16px;
    line-height: 22px;
    padding-left: ${({ store }: StyledProps) => store ? '20px' : 'auto'};
    &:focus {
      box-shadow: ${({ manualMode }: StyledProps) => manualMode ? '0px 1px 5px 2px #080808 !important' : 'unset'};
      transform: ${({ manualMode }: StyledProps) => manualMode ? 'scale(1.02)' : 'unset'};
    }
  }
`

export const AdvancedSearch = styled.div`
  font-size: 12px;
  padding-top: 4px;
  margin-bottom: -4px;
  background: #f0f0f0;
  width: fit-content;
  padding-left: 14px;
  padding-right: 8px;
  padding-bottom: 4px;
  border-bottom-left-radius: 70px;
  border-bottom-right-radius: 25px;
  float: right;
  font-family: Avenir;
  color: #5a8dc9;
  transition: all .25s;
  ${({ mobile }: StyledProps) => mobile ? `
    margin-bottom: -30px;
    font-size: 11px;
    border-bottom-left-radius: 10px;
    padding-left: 8px;
    border-bottom-right-radius: 10px;
  ` : ''}
  &:hover {
    cursor: pointer;
  }
`

export const SearchIcon = styled(Icon)`
  transform: scaleX(-1);
  margin-right: 6px;
  font-size: 11px;
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/SearchBar/styledComponents.tsx